<template>
    <div>
        <hts-form-select
            v-model="cValue"
            v-model:text="cText"
            v-model:selected="selectedTask"
            :label="label"
            :items="cTasks"
            :required="required"
            :disabled="disabled"
            :readonly="readonly"
            :name="name"
            :prop="prop"
            key-id="_id"
            key-label="name"
            @change="handleChange">
            <template #default="{ item }">
                <span>
                    {{ item.name }}
                </span>
                <div class="block w-full">
                    <template v-if="item.businesses && Array.isArray(item.businesses) && item.businesses.length">
                        <div
                            v-for="(business, index) in item.businesses"
                            :key="index">
                            <span class="inline-block whitespace-nowrap overflow-hidden text-ellipsis max-w-xs text-sm p-1 m-1 border rounded text-gray-500">
                                {{ getBusinessName(business) }}
                            </span>
                        </div>
                    </template>
                </div>
            </template>
        </hts-form-select>
        <slot
            name="footer"
            :items="selectedTask"
            :get-business-name="getBusinessName" />
    </div>
</template>

<script lang="ts" setup>
const store = $store()
const props = defineProps({
  modelValue: {
    type: [Array, String],
    default: () => ''
  },
  prop: String,
  name: String,
  text: String,
  required: Boolean,
  label: {
    type: String,
    default: () => $t('labels.task')
  },
  placeholder: String,
  readonly: Boolean,
  disabled: Boolean,
  taskType: String,
  items: Array
})
const emits = defineEmits(['update:modelValue', 'update:text', 'click', 'change'])
const tasks = computed(() => store.data.tasks)
const businesses = computed(() => store.data.businesses)
const selectedTask = ref(null)

const { modelValue, text, taskType, items } = toRefs(props)
const cTasks = computed(() => {
  if (items?.value) {
    return items.value
  }
  if (taskType?.value) {
    return tasks.value.filter((task: any) => task.taskType === taskType?.value)
  }
  return tasks.value
})
const cValue = computed({
  get () {
    return modelValue.value
  },
  set (val: any) {
    emits('update:modelValue', val)
  }
})
const cText = computed({
  get () {
    return text?.value
  },
  set (val: any) {
    emits('update:text', val)
  }
})

const handleChange = (val: any) => {
  emits('change', val)
}

const getBusinessName = (business: any) => {
  if (typeof business === 'string') {
    const exists: any = businesses.value.find((b: any) => b._id === business)
    if (exists) {
      return exists.name || ''
    }
  }
  return business?.name || ''
}
</script>
